import { useQuery, useQueryClient } from "react-query";
import { Plan } from "../types";
import { getBaseUrl, handleResponse } from "../utils";

const useGetPlans = ({ dispatch, errorText, plans, blacklistedPlans, reset }: { dispatch: any, errorText: string, plans: Plan[], blacklistedPlans: String[], reset?: Function }) => {
  const queryClient = useQueryClient();

  return useQuery<Plan[]>('plans', () => fetch(`${getBaseUrl()}/api/billing/user/anon/plans`, { method: 'GET' }).then((res: any) => handleResponse(res)), {
    enabled: true,
    initialData: () =>
      queryClient.getQueryData('plans') ||
      undefined,
    onError: (error) => {
      console.error('Error with plans request: ', error);
      dispatch({
        type: 'ADD_MESSAGE',
        payload: {
          dismissable: true,
          id: new Date().getTime(),
          text: errorText,
          timeout: 7,
          type: 'error',
        },
      });
    },
    onSuccess: (data) => {
      var result = data.filter(plan => blacklistedPlans.indexOf(plan.billingCycle) < 0);
      /**
       * Save plans to state
       */
      dispatch({
        type: 'SET_PLANS',
        payload: result,
      });
    },
  });
}

export default useGetPlans